import type { AssessmentQuestion } from '@entities/assessment'

import { AssessmentTopics } from '@entities/assessment'

import imgQuestion2 from '../../../../ui/images/questions/ela/grade-k7/question-2.png'
import imgQuestion5 from '../../../../ui/images/questions/ela/grade-k7/question-5.png'
import imgQuestion7 from '../../../../ui/images/questions/ela/grade-k7/question-7.png'

export const questionsTest: AssessmentQuestion[] = [
  {
    name: 'grade_k7_1',
    title: 'If a speaker describes a situation as "the elephant in the room," what does he mean?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    answers: [
      {
        name: 'grade_k7_1_a',
        text: 'There is a large, physical obstacle preventing progress.',
      },
      {
        name: 'grade_k7_1_b',
        text: 'There is an obvious, major problem that everyone is intentionally ignoring.',
        correct: true,
      },
      {
        name: 'grade_k7_1_c',
        text: 'The atmosphere in the room is crowded and uncomfortable.',
      },
    ],
  },
  {
    name: 'grade_k7_2',
    title: 'You hear this statement in a group discussion:',
    topic: AssessmentTopics.ListeningAndSpeaking,
    detail: '"I see your point, but have you thought about it this way?"',
    sentence: 'What is the speaker doing?',
    image: imgQuestion2,
    answers: [
      {
        name: 'grade_k7_2_a',
        text: 'Ignoring others\u2019 ideas.',
      },
      {
        name: 'grade_k7_2_b',
        text: 'Agreeing without question.',
      },
      {
        name: 'grade_k7_2_c',
        text: 'Offering a different perspective politely.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k7_3',
    title: 'You hear these instructions:',
    topic: AssessmentTopics.ListeningAndSpeaking,
    detail: '"After you finish your worksheet, please pack up your materials quietly and wait for the next activity."',
    sentence: 'What should you do first?',
    answers: [
      {
        name: 'grade_k7_3_a',
        text: 'Pack up your materials.',
      },
      {
        name: 'grade_k7_3_b',
        text: 'Wait for the next activity.',
      },
      {
        name: 'grade_k7_3_c',
        text: 'Finish your worksheet.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k7_4',
    title: 'Choose the most credible evidence to support a claim about climate change:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    answers: [
      {
        name: 'grade_k7_4_a',
        text: 'My uncle, who has lived on a farm for 40 years, says the summers are hotter.',
      },
      {
        name: 'grade_k7_4_b',
        text: 'A popular post on a social media site claims that the ice caps are melting fast.',
      },
      {
        name: 'grade_k7_4_c',
        text: 'According to data from the National Oceanic and Atmospheric Administration, global temperatures have risen steadily since 1880.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k7_5',
    title: 'Read the text:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '"Renewable energy sources like solar and wind power are becoming more popular because they are cleaner and more sustainable than fossil fuels. Unlike coal and oil, these sources do not produce harmful emissions that contribute to climate change. Many countries are investing in renewable energy to protect the environment and create jobs."',
    sentence: 'What is the main purpose of this passage?',
    image: imgQuestion5,
    answers: [
      {
        name: 'grade_k7_5_a',
        text: 'To explain how fossil fuels work.',
      },
      {
        name: 'grade_k7_5_b',
        text: 'To inform readers about the benefits of renewable energy.',
        correct: true,
      },
      {
        name: 'grade_k7_5_c',
        text: 'To describe the process of climate change.',
      },
    ],
  },
  {
    name: 'grade_k7_6',
    title: 'Read the text:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '"Electric vehicles are gaining popularity because they reduce air pollution compared to gasoline cars. Although they are expensive, many countries are investing in them to protect the environment and stimulate the economy by creating new green jobs."',
    sentence: 'What is the main idea of the passage?',
    answers: [
      {
        name: 'grade_k7_6_a',
        text: 'Gasoline cars will be completely banned in the near future.',
      },
      {
        name: 'grade_k7_6_b',
        text: 'The shift to clean energy provides both environmental and financial benefits.',
        correct: true,
      },
      {
        name: 'grade_k7_6_c',
        text: 'Buying an electric car is currently too expensive for most people.',
      },
    ],
  },
  {
    name: 'grade_k7_7',
    title: 'Choose the word that best completes the sentence:',
    topic: AssessmentTopics.Writing,
    detail: 'The teacher was very ______ because she explained the lesson clearly.',
    image: imgQuestion7,
    answers: [
      {
        name: 'grade_k7_7_a',
        text: 'confused',
      },
      {
        name: 'grade_k7_7_b',
        text: 'angry',
      },
      {
        name: 'grade_k7_7_c',
        text: 'patient',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k7_8',
    title: 'Which sentence uses a semicolon correctly?',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k7_8_a',
        text: 'I went to the store; and bought some milk.',
      },
      {
        name: 'grade_k7_8_b',
        text: 'I went to the store; bought some milk.',
      },
      {
        name: 'grade_k7_8_c',
        text: 'I went to the store; I bought some milk.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k7_9',
    title: 'Choose the sentence that is written as a complex sentence:',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k7_9_a',
        text: 'I wanted to go to the park, but it started to rain.',
      },
      {
        name: 'grade_k7_9_b',
        text: 'Because I forgot my lunch, I had to buy a sandwich at school.',
      },
      {
        name: 'grade_k7_9_c',
        text: 'Although I was tired, I finished my project, and then I went to sleep.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k7_10',
    title: 'Identify the function of the gerund in this sentence:',
    topic: AssessmentTopics.Language,
    detail: 'Developing new habits requires time and persistence.',
    answers: [
      {
        name: 'grade_k7_10_a',
        text: 'Subject of the sentence.',
        correct: true,
      },
      {
        name: 'grade_k7_10_b',
        text: 'Direct object of the verb.',
      },
      {
        name: 'grade_k7_10_c',
        text: 'Object of a preposition.',
      },
    ],
  },
  {
    name: 'grade_k7_11',
    title: 'Which sentence is written in passive voice?',
    topic: AssessmentTopics.Language,
    answers: [
      {
        name: 'grade_k7_11_a',
        text: 'The teacher gave the students homework.',
      },
      {
        name: 'grade_k7_11_b',
        text: 'The homework was given to the students by the teacher.',
        correct: true,
      },
      {
        name: 'grade_k7_11_c',
        text: 'The students completed their homework.',
      },
    ],
  },
  {
    name: 'grade_k7_12',
    title: 'Which sentence uses commas correctly?',
    topic: AssessmentTopics.Language,
    answers: [
      {
        name: 'grade_k7_12_a',
        text: 'Before the movie started we bought, popcorn and drinks.',
      },
      {
        name: 'grade_k7_12_b',
        text: 'Before the movie started, we bought popcorn and drinks.',
        correct: true,
      },
      {
        name: 'grade_k7_12_c',
        text: 'Before the movie, started we bought popcorn and drinks.',
      },
    ],
  },
]
